import React, { useEffect, useState } from 'react';
import { translation } from '../../helper/translation';

export const CookieConsent = () => {
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setShowConsent(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setShowConsent(false);
    };

    const handleTechnicalOnly = () => {
        localStorage.setItem('cookieConsent', 'technical');
        setShowConsent(false);
    };

    if (!showConsent) return null;

    return (
        <div className="cookie-consent">
            <div className="cookie-consent-content">
                <h4>{translation('cookie-consent-title')}</h4>
                <p>{translation('cookie-consent-message')}</p>
                <div className="cookie-consent-buttons">
                    <button type="button" className="btn btn-primary" onClick={handleAccept}>
                        {translation('cookie-consent-accept')}
                    </button>
                    <button type="button" className="btn btn-outline-secondary" onClick={handleTechnicalOnly}>
                        {translation('cookie-consent-technical')}
                    </button>
                </div>
            </div>
        </div>
    );
};
